import { render, staticRenderFns } from "./TipTapTopMenu.vue?vue&type=template&id=9508aa78&scoped=true&"
import script from "./TipTapTopMenu.vue?vue&type=script&lang=js&"
export * from "./TipTapTopMenu.vue?vue&type=script&lang=js&"
import style0 from "./TipTapTopMenu.vue?vue&type=style&index=0&id=9508aa78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9508aa78",
  null
  
)

export default component.exports